var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistantTeamLeadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49318 7.19535C9.07885 7.19535 10.3643 5.90991 10.3643 4.32424C10.3643 2.73857 9.07885 1.45312 7.49318 1.45312C5.90751 1.45312 4.62207 2.73857 4.62207 4.32424C4.62207 5.90991 5.90751 7.19535 7.49318 7.19535Z",
    fill: "#595DB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 12.4453H12.4446V13.0675H9.3335V12.4453Z",
    fill: "#595DB5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6669 13.3334V14.6668C6.6669 14.7846 6.71372 14.8977 6.79707 14.981C6.88042 15.0644 6.99347 15.1112 7.11134 15.1112H14.6669C14.7848 15.1112 14.8978 15.0644 14.9812 14.981C15.0645 14.8977 15.1113 14.7846 15.1113 14.6668V10.2223C15.1113 10.1045 15.0645 9.99141 14.9812 9.90806C14.8978 9.82471 14.7848 9.77788 14.6669 9.77788H11.5558V9.12455C11.5558 9.00668 11.509 8.89363 11.4256 8.81028C11.3423 8.72693 11.2292 8.6801 11.1113 8.6801C10.9935 8.6801 10.8804 8.72693 10.7971 8.81028C10.7137 8.89363 10.6669 9.00668 10.6669 9.12455V9.77788H9.77801V8.18677C9.02279 8.06319 8.25883 8.00077 7.49357 8.0001C5.80592 7.99293 4.13719 8.3555 2.60468 9.06233C2.35245 9.18136 2.13966 9.37024 1.99155 9.60658C1.84345 9.84291 1.76625 10.1168 1.76912 10.3957V13.3334H6.6669ZM14.2225 14.2223H7.55579V10.6668H10.6669V10.8534C10.6669 10.9713 10.7137 11.0844 10.7971 11.1677C10.8804 11.2511 10.9935 11.2979 11.1113 11.2979C11.2292 11.2979 11.3423 11.2511 11.4256 11.1677C11.509 11.0844 11.5558 10.9713 11.5558 10.8534V10.6668H14.2225V14.2223Z",
    fill: "#595DB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantTeamLeadIcon);
export default __webpack_public_path__ + "static/media/AssistantTeamLeadIcon.a3809377e2e9d86ef6d9ef1e1886abae.svg";
export { ForwardRef as ReactComponent };